import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

import PublicBreadcrumb from "../../components/PublicBreadcrumb";
import LandingFooter from "../LandingPage/LandingFooter";
import LandingNavbar from "../LandingPage/LandingNavbar";

import "../LandingPage/LandingPage.css";
import "./articleDocument.css";

type ArticleLayoutProps = {
  eyebrow: string;
  title: string;
  lead: string;
  children: ReactNode;
};

/**
 * Public marketing/content page shell.
 *
 * Same look-and-feel as the landing page (nav + footer + glow background),
 * but with article-oriented typography and a final CTA block.
 */
export default function ArticleLayout({
  eyebrow,
  title,
  lead,
  children,
}: ArticleLayoutProps) {
  const { pathname } = useLocation();

  return (
    <div className="landing-page">
      <div className="landing-page__glow landing-page__glow--left" aria-hidden="true" />
      <div className="landing-page__glow landing-page__glow--right" aria-hidden="true" />

      <LandingNavbar />

      <main className="article-doc">
        <div className="article-doc__inner">
          <PublicBreadcrumb path={pathname} />

          <article className="article-doc__panel">
            <p className="article-doc__eyebrow">{eyebrow}</p>
            <h1 className="article-doc__title">{title}</h1>
            <p className="article-doc__lead">{lead}</p>

            <div className="article-doc__body">{children}</div>

            <aside className="article-doc__cta">
              <h2>Vrei foi de parcurs gata în câteva minute pe lună?</h2>
              <p>
                AIFoiParcurs completează automat perioadele lipsă, validează coerența
                kilometri–consum–rezervor și exportă rezultatul gata pentru contabil.
                Testează gratuit 2 luni, fără card.
              </p>
              <div className="article-doc__cta-actions">
                <Link to="/login" className="article-doc__cta-button">
                  Testează gratuit
                </Link>
                <Link to="/#preturi" className="article-doc__cta-link">
                  Vezi prețurile
                </Link>
              </div>
            </aside>
          </article>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
